import React from 'react';
import { CloseIconWrapper, CloseIcon } from 'Screens/Contextualization/Host/components/HostDetail/components/Header/styled';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/modals/actions';
import { MODAL_AGENT_EXECUTOR_DETAIL } from 'store/modals/modals';
import { Wrapper, DataContainer, AgentIcon } from './styled';
import { RunIcon } from 'Screens/Automation/Agents/components/AgentDetail/components/UserAgentDetail/components/Content/Tools/Tool/styled';
import ToolInfo from './ToolInfo';
import { Logo } from 'Screens/Automation/Agents/components/CreateNewAgent/components/Tools/components/Card/styled';
import { selectAgentExecutionSelected, selectAgentExecutionType } from 'store/Agents/selectors';
import { get } from 'lodash';
import { runAgentFromLogs, runCloudAgentFromLogs } from 'store/Agents/actions';
import StatusInfo from './StatusInfo';

const Header = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectAgentExecutionSelected);
  const executorData = get(data, '[0].parameters_data', {});
  const typeTool = get(data, '[0].tool', {});
  const executor = get(executorData, 'executor_data.executor', '');
  const agentType = useSelector(selectAgentExecutionType);
  const isCloud = agentType !== 'agent_executions';
  const logo = isCloud ? <AgentIcon /> : <Logo type={ typeTool } small />;

  const run = () => isCloud ? dispatch(runCloudAgentFromLogs()) : dispatch(runAgentFromLogs());
  const close = () => dispatch(closeModal(MODAL_AGENT_EXECUTOR_DETAIL));

  return (
    <Wrapper>
        <DataContainer>
          { logo }
          {/* <Logo type={ isCloud ? 'nmap' : typeTool } /> */}
          <ToolInfo type={ executor } isCloud={ isCloud } />
          <StatusInfo />
          <RunIcon onClick={ run } />
        </DataContainer>
        <CloseIconWrapper>
          <CloseIcon onClick={ close } />
        </CloseIconWrapper>
    </Wrapper>
  );
};

export default Header;
